<template>
  <div>
      <HeaderIndex></HeaderIndex>
      <router-view/>
      <FooterIndex name="footerIndex"></FooterIndex>
  </div>
</template>


<script>

import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import  '../assets/css/css.css'

export default {
  name: 'ModuleIndex',
  data () {
    return {
    }
  },
  components: {
      FooterIndex,HeaderIndex
  },
  mounted() {
    
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ModuleMain.vue